import React,{Component} from "react";
import Box from '@material-ui/core/Box';

export default class Ru extends Component{


    render() {
        const {classes} = this.props;
        return <>
            <h1>ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ</h1>
            <Box component="p" m={1}>
                ООО “ГритТек” ("GRITTEC") будет предлагать использовать свои сервисы и услуги, размещенные на сайтах Speaker-ID.ru, Speaker-ID.com (Сайт), только при условии принятия конечным пользователем
                (Пользователь) всех условий настоящего пользовательского соглашения (Соглашение).<br/>
                Внимательно прочтите данное соглашение. Начиная использовать какой-либо сервис или услугу GRITTEC, либо
                пройдя процедуру регистрации на Сайте, Пользователь безоговорочно принимает все условия этого соглашения.
            </Box>
            <Box component="p" m={1}>
                ЕСЛИ ПОЛЬЗОВАТЕЛЬ НЕ СОГЛАСЕН С УСЛОВИЯМИ НАСТОЯЩЕГО СОГЛАШЕНИЯ, ТО В ЭТОМ СЛУЧАЕ ПОЛЬЗОВАТЕЛЬ НЕ МОЖЕТ ИСПОЛЬЗОВАТЬ СЕРВИСЫ
                И УСЛУГИ GRITTEC, А GRITTEC НЕ ОБЯЗУЕТСЯ ПРЕДОСТАВЛЯТЬ СВОИ СЕРВИСЫ И УСЛУГИ ПОЛЬЗОВАТЕЛЮ.
            </Box>
            <Box component="p" m={1}>
                В СЛУЧАЕ ЕСЛИ GRITTEC ВНЕС КАКИЕ-ЛИБО ИЗМЕНЕНИЯ В СОГЛАШЕНИЕ, ПРЕДУСМОТРЕННОЕ ПУНКТОМ 15 ДАННОГО СОГЛАШЕНИЯ,
                С КОТОРЫМ ПОЛЬЗОВАТЕЛЬ НЕ СОГЛАСЕН, ТО ПОЛЬЗОВАТЕЛЬ ОБЯЗАН ПРЕКРАТИТЬ ИСПОЛЬЗОВАНИЕ СЕРВИСОВ И УСЛУГ GRITTEC.
            </Box>
            <br/>
            <h2>1. ОПРЕДЕЛЕНИЯ.</h2>
            <Box component="p" m={3}>
                Термин "Пользователь" означает физическое лицо, которое заказывает сервисы и услуги GRITTEC.<br/>
                Термин "Регистрация" означает процесс, в ходе которого Пользователь предоставляет свои персональных данные
                для получения доступа к сервисам и услугам GRITTEC, путем заполнения регистрационной формы на Сайте .<br/>
                Термин "Персональные данные" означает любая информация, относящаяся к прямо или косвенно определенному
                или определяемому физическому лицу.<br/>
            </Box>
            <h2>2. РЕГИСТРАЦИЯ/АВТОРИЗАЦИЯ ПОЛЬЗОВАТЕЛЯ.</h2>
            <Box component="p" m={3}>
                Пользователю необходимо пройти регистрацию на Сайте для использования сервисами и услугами GRITTEC, в результате
                которой для Пользователя будет создана уникальная учетная запись с UID индентификатором.<br/>
                Пользователи не достигшие 14 лет не вправе самостоятельно производить регистрацию учетной записи, однако регистрация возможна
                с согласия родителей или иных законных представителей.<br/>
                GRITTEC на свое усмотрении вправе отказать в регистрации любому Пользователю без всяких на то оснований.<br/>
                UID индентификатор позволяет GRITTEC получать необходимые данные о Пользователе, а также позволяет Пользователю:<br/>
                (1) хранить в сервисе GRITTEC данные третих лиц, связанные с использованием сервисов и услуг GRITTEC, <br/>
                (2) предоставлять третьим лицам доступ к сервисам и услугам GRITTEC,<br/>
                (3) менять и удалять данные, которые могут обрабатываться в связи с предоставлением сервисов и услуг GRITTEC,<br/>
                (4) давать и отзывать согласия на обработку данных лицам, использующие сервисы и услуги GRITTEC.<br/>
                Для ясности, зарегистрированный Пользователь с UID индентификатором, является владельцем персональных данных,
                и несет ответственность за соблюдение требований законодательства о персональных данных при их обработке.<br/>
           </Box>
            <h2>3. УСЛОВИЯ ИСПОЛЬЗОВАНИЯ.</h2>
            <Box component="p" m={3}>
                В соответствии с условиями настоящего Соглашения, Пользователь несет полную ответственность при использовании
                сервисов и услуг GRITTEC:<br/>
                (1) перед третьими лицами, в том числе перед несовершеннолетними лицами,<br/>
                (2) за соблюдение законодательства, в том числе международного права.<br/>
                Соглашение не дает права распространять или передавать третьими лицами сервисы и услуги GRITTEC или его части каким-либо
                образом без письменного разрешения GRITTEC.<br/>
            </Box>
            <h2>4. ОГРАНИЧЕНИЯ.</h2>
            <Box component="p" m={3}>
                Пользователь соглашается использовать сервисы и услуги GRITTEC только для целей, которые не нарушают права третьих лиц,
                в том числе несовершеннолетних лиц, норм законодатльства и норм международного права.<br/>

                Пользователь не имеет права сублицензировать, копировать, дублировать, модифицировать, осуществлять обратную разработку,
                декомпилировать, дизассемблировать, изменять структуру или вносить какие-либо изменения в сервисы и услуги GRITTEC.<br/>

                Пользователь не имеет права препятствовать, нарушать и/или содействовать нарушениям работы сервисов и услуг GRITTEC.<br/>

                Пользователь не имеет права загружать, распространять данные, которые является незаконными, вредоносными, содержащие вирусы
                и/или шпионские программы, демонстрируют насилие, жестокость, имеют признак секусального характера, пропагандируют ненависть,
                оружие, наркотические вещества, пропагандируют дискриминацию людей по половому, религиозному, расовому и/или этническим признакам,
                содержит оскорбления и/или клевету в адрес третих лиц,<br/>

                Пользователь признает, что сервисы и услуги GRITTEC не разработаны и не предназначены для использования в
                каких-либо критически важных проектах, конструкциях, эксплуатации или обслуживании. GRITTEC отказывается от каких-либо явных или
                подразумеваемых гарантий пригодности для таких целей.<br/>
            </Box>
            <h2>5. ЦЕНЫ, НАЛОГИ И НАЦЕНКИ.</h2>
            <Box component="p" m={3}>
                Цена за сервисы и услуги GRITTEC сформулированы на главной страницы Сайта. Все цены и вышеизложенные платы исключительны от налогов и других плат.
                За исключением налогов, основанных на доходе GRITTEC, Пользователь должен заплатить любые федеральные, государственные, местные и
                иностранные налоги, платы или пошлины, наложенные на продажу, экспорт, использование сервисами и услугами GRITTEC,
                включая штрафы и проценты. Пользователь должен оплатить все такие счета или как наложено соответствующими налоговыми органами
                или как выставлено в счет GRITTEC, или, вместо этого, Пользователь должен обеспечить свидетельство освобождения,
                приемлемое для соответствующих налоговых органов.
            </Box>
            <h2>6. ОПЛАТА.</h2>
            <Box component="p" m={3}>
                Для использования сервисов и услуг GRITTEC Пользователь должен предварительно их полностью оплатить.
                Стоимость сервисов и услуг GRITTEC определена на главной страницы Сайта.
                Все платежи должны быть сделаны напрямую на расчетный счет GRITTEC.
            </Box>
            <h2>7. ИСКЛЮЧИТЕЛЬНЫЕ ПРАВА.</h2>
            <Box component="p" m={3}>
                Все исключительные права собственности на сервисы и услуги GRITTEC, прилагаемые к нему печатные материалы,
                элементы дизайна, графические изображения, видео, программы для ЭВМ, базы данных принадлежат компании GRITTEC.<br/>
                Контент данных размещенный на сервисах GRITTEC, является исключительным правом собственности GRITTEC,
                зарегистрированных Пользователей и других правообладателей.<br/>
            </Box>
            <h2>8. ТОВАРНЫЕ ЗНАКИ И ЭМБЛЕМЫ.</h2>
            <Box component="p" m={3}>
                Все товарные знаки, знаки обслуживания, логотипы и другие фирменные наименования и обозначения GRITTEC защищены
                законодательством Российской Федерации и положениями международных договоров.<br/>
                Копирование печатных материалов, прилагаемых к сервисам и услугам GRITTEC, разрешенно только с письменного согласия GRITTEC.<br/>
            </Box>
            <h2>9. УПРАВЛЕНИЕ ЗАКОНОМ.</h2>
            <Box component="p" m={3}>
                Настоящее Соглашение регулируется законодательством Российской Федерации, и каждая сторона безвозвратно
                подчиняется исключительной юрисдикции российских судов. Никакие нормы закона какой-либо юрисдикции не применяются.
                Все требования относительно этого Соглашения можно услышать, и должны быть разрешены в Арбитражном суде г. Москвы.
            </Box>
            <h2>10. ОЗНАКОМЛЕНИЕ.</h2>
            <Box component="p" m={3}>
                GRITTEC может предоставить возможность бесплатно оценить сервисы и услуги GRITTEC, предоставив Пользователю
                доступ к Сайту или иным способом. Использование сервисов и услуг GRITTEC  для ознакомления означает согласие
                Пользователя с настоящим Соглашением.<br/>
                Срок действия пробного периода ограничен не более тридцатью (30) днями. По истечении пробного периода
                Соглашение должно быть завершено, а Пользователю заблокируется доступ к сервисам и услугам GRITTEC.
            </Box>
            <h2>11. СРОК ДЕЙСТВИЯ.</h2>
            <Box component="p" m={3}>
                Данное Соглашение действует до момента его расторжения. GRITTEC имеет право в одностороннем порядке
                расторгнуть Соглашение, если Пользователь нарушил любое из положений настоящего Соглашения.
                В этом случае Пользователю будет заблокирован доступ к сервисам и услугам GRITTEC.
            </Box>
            <h2>12. ОТКАЗ ОТ ГАРАНТИЙ.</h2>
            <Box component="p" m={3}>
                За исключением случаев, явно указанных в настоящем Соглашении, GRITTEC не предоставляет никаких гарантий, явных,
                подразумеваемых или установленных нормами законодательства, в отношении любых других вопросов, включая, но
                не ограничиваясь, гарантии ненарушения прав третих лиц, товарного качества или пригодности для какой-либо конкретной цели.<br/>
                GRITTEC не гарантирует и не может гарантировать производительность или результаты, которые Пользователь может получить,
                используя сервисы и услугы GRITTEC.
            </Box>
            <h2>13. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ.</h2>
            <Box component="p" m={3}>
                Ни GRITTEC, ни кто-либо другой, участвовавший в создании, производстве сервисов и услуг GRITTEC,
                являющейся предметом настоящего Соглашения, не несут ответственности за любые косвенные, последующие или
                случайные убытки (включая убытки от потери прибыли, перерыва в коммерческой деятельности, потери деловой информации и т. п.),
                возникшие в результате использования или невозможности использования сервисов и услуг GRITTEC, даже если
                Пользователь был уведомлен о возможности таких убытков.
            </Box>
            <h2>14. ИСХОДНЫЙ КОД.</h2>
            <Box component="p" m={3}>
                Сервисы и услуги GRITTEC могут предоставлять  и/или содержать исходный код, который, если иное прямо не
                лицензировано для иных целей, предоставляется исключительно в справочных целях в соответствии с условиями
                настоящего Соглашения. Распространение исходного кода запрещено, если иное прямо не предусмотрено настоящим Соглашением.
            </Box>
            <h2>15. ОБНОВЛЕНИЕ.</h2>
            <Box component="p" m={3}>
                Процессы обновления сервисов и услуг GRITTEC могут привести к определенным ограничениям их работы в период таких обновлений.
                GRITTEC будет уведомлять заранее Пользователя о времени и периоде таких обновлений, но
                не позднее двенадцати (12) часов до начала такого обновления.<br/>
                GRITTEC на свое усмотрение может обновлять данное Соглашение. Пользователь обязан принять все такие изменения, в противном случае
                Пользователь не может использовать сервисы и услуги GRITTEC.
            </Box>
            <h2>16. ЗАВЕРШЕНИЕ.</h2>
            <Box component="p" m={3}>
                Данное Соглашение действует до момента его расторжения. Пользователь может расторгнуть настоящее Соглашение в любое время,
                отправив уведомление GRITTEC о преостановлении доступа к сервисам и услугам GRITTEC.<br/>
                GRITTEC может расторгнуть настоящее Соглашение немедленно без предварительного уведомления от GRITTEC,
                если Пользователь не соблюдает какие-либо положения настоящего Соглашения.<br/>
                GRITTEC оставляет за собой право расторгнуть настоящее Соглашение без предварительного уведомления от GRITTEC,
                если Пользователь не пользовался сервисами и услугами GRITTEC в течении трех (3-х) лет, с момента последнего пользования.<br/>
                После расторжения Соглашения доступ к сервисам и услугам GRITTEC будет заблокирован Пользователю.
            </Box>
            <h2>17. ОТДЕЛИМОСТЬ.</h2>
            <Box component="p" m={3}>
                Если какая-либо часть настоящего Соглашения будет признана недействительной или недействительной окончательным решением
                любого суда компетентной юрисдикции, остальная часть настоящего Соглашения продолжает действовать между сторонами,
                как если бы часть, признанная недействительной или недействительной, была исключена из Соглашения в момент его вступления в силу.
            </Box>
            <h2>18. ФОРС-МАЖОР.</h2>
            <Box component="p" m={3}>
                Ни одна из сторон не несет ответственности за неисполнение каких-либо обязательств или непредоставление услуг по настоящему
                Соглашению в связи со стихийными бедствиями, забастовкой, прекращением работы, правительственными актами или распоряжениями,
                войной, беспорядками или гражданскими волнениями, нехваткой оборудования или помещений или другими аналогичными
                обстоятельствами, находящимися вне разумного контроля такой стороны.
            </Box>
            <h2>19. СЕРВИС УВЕДОМЛЕНИЙ.</h2>
            <Box component="p" m={3}>
                Любое уведомление, направляемое в соответствии с настоящим Соглашением, должно быть составлено на русском языках
                и считается надлежащим образом направленным, если оно отправлено по электронной почте получающей стороны.
            </Box>
            <Box component="p" m={1}>
                Обновлено: 2025.10.10
            </Box>
        </>;
    }
}

